var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-info',{ref:"dialog",attrs:{"title":_vm.title,"customClass":"dialog-connect-open-po"},on:{"close":_vm.handlerClose}},[_c('list-form',{ref:"list-form",attrs:{"formModel":_vm.formModel,"config":_vm.config},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
var item = ref.item;
var autoSave = ref.autoSave;
return [_c('activity-item-po',{attrs:{"data":data,"item":item,"formModel":_vm.formModel,"autoSave":autoSave},on:{"onSendEmail":_vm.handlerSendEmail,"updatedData":_vm.refresh}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }